import getApiClient from '@/plugins/api-client'
import banner from '@/dto/banner'

export default {
    load(id) {
        const self = this,
            api = getApiClient(self.$store)

        api.get(`banners/${id}`)
            .then(result => {
                self.banner = Object.assign(banner, result.data)
            })
            .catch(error => {
                console.log(error)
            })
    },
    save() {
        const self = this,
            id = self.banner.id

        if (! self.banner.image || self.banner.image && ! self.banner.image.match(/base64/g)) {
            self.$delete(self.banner, 'image')
        }

        if (! self.banner.footerImage || self.banner.footerImage && ! self.banner.footerImage.match(/base64/g)) {
            self.$delete(self.banner, 'footerImage')
        }

        if (id) {
            return self.update()
        }

        return self.create()
    },
    create() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.post('banners', self.banner)
            .then(result => {
                self.banner = result.data
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },
    update() {
        const self = this,
            api = getApiClient(self.$store)

        self.resetFormResult()

        api.patch(`banners/${self.banner.id}`, self.banner, {
            headers: {
                'Content-Type': 'application/merge-patch+json'
            }
        })
            .then(result => {
                self.banner = result.data
                self.success = true
            })
            .catch(error => {
                switch (error.response.status) {
                    case 400:
                    case 422:
                        let violations = error.response.data.violations
                        violations.forEach((violation) => {
                            self.errors[violation.propertyPath] = violation.message
                        })
                        break;
                }
            })
    },

    resetFormResult() {
        const self = this
        Object.keys(self.errors).forEach((error) => {
            self.errors[error] = null
        })
        self.success = false
    },

    setImage(files) {
        const self = this,
            image = files[0],
            reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = e => {
            self.banner.image = e.target.result;
        }
    },

    setMobileImage(files) {
        const self = this,
            image = files[0],
            reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = e => {
            self.banner.mobileImage = e.target.result;
        }
    },

    setFooterImage(files) {
        const self = this,
            image = files[0],
            reader = new FileReader()
        reader.readAsDataURL(image)
        reader.onload = e => {
            self.banner.footerImage = e.target.result;
        }
    },

    setBannerGradient(checked) {
        this.banner.gradient = checked
    }
}
